import { Resource } from './Resource.js';
import { getDistance } from '../utils/math.js';
import { AI_CONFIG, RESOURCE_CONFIG, ANIMATION_CONFIG } from '../config.js';

export class Crystal extends Resource {
  constructor(x, y) {
    super(x, y, RESOURCE_CONFIG.CRYSTAL_UNITS_GRANTED);
    
    // Crystal-specific properties
    this.glowIntensity = 0.5;
    this.rotation = 0;
  }
  
  updateSpecific(delta) {
    // Update glow effect
    this.glowIntensity = ANIMATION_CONFIG.CRYSTAL_GLOW_BASE + 
                         Math.sin(this.pulseTimer * ANIMATION_CONFIG.CRYSTAL_GLOW_SPEED) * 
                         ANIMATION_CONFIG.CRYSTAL_GLOW_VARIATION;
    this.rotation += ANIMATION_CONFIG.CRYSTAL_ROTATION_SPEED;
  }
  
  // Crystals can be collected by any unit
  canBeCollectedBy(soldier) {
    if (this.isBeingCollected) return false;
    const distance = getDistance(this, soldier);
    return distance <= AI_CONFIG.CORPSE_COLLECTION_RADIUS;
  }
  
  // Collecting a crystal grants instant units
  collect(collector) {
    return { type: 'crystal', amount: RESOURCE_CONFIG.CRYSTAL_UNITS_GRANTED };
  }
  
  // Override render to handle rotation
  render(ctx) {
    if (!this.active) return;
    
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rotation);
    
    // Draw glow
    const glowGradient = ctx.createRadialGradient(0, 0, 0, 0, 0, 15);
    glowGradient.addColorStop(0, `rgba(100, 255, 255, ${this.glowIntensity})`);
    glowGradient.addColorStop(1, 'rgba(0, 150, 255, 0)');
    ctx.fillStyle = glowGradient;
    ctx.beginPath();
    ctx.arc(0, 0, 15, 0, Math.PI * 2);
    ctx.fill();
    
    // Draw crystal shape
    ctx.strokeStyle = '#00ffff';
    ctx.lineWidth = 2;
    ctx.globalAlpha = 0.8 + this.glowIntensity * 0.2;
    
    // Hexagonal crystal
    ctx.beginPath();
    for (let i = 0; i < 6; i++) {
      const angle = (i * Math.PI * 2) / 6;
      const x = Math.cos(angle) * 8 * this.scale;
      const y = Math.sin(angle) * 8 * this.scale;
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.closePath();
    ctx.stroke();
    
    // Inner detail
    ctx.lineWidth = 1;
    ctx.globalAlpha = 0.5;
    for (let i = 0; i < 6; i++) {
      const angle = (i * Math.PI * 2) / 6;
      const x = Math.cos(angle) * 8 * this.scale;
      const y = Math.sin(angle) * 8 * this.scale;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(x, y);
      ctx.stroke();
    }
    
    ctx.restore();
  }
  
  // Crystal doesn't use the base renderSpecific
  renderSpecific(ctx, pulse) {
    // Not used - we override render() directly
  }
}